// extracted by mini-css-extract-plugin
module.exports = {"cell":"TableCellNode_cell__qRt6X","cellMount":"TableCellNode_cellMount__FGhiJ","menu":"TableCellNode_menu__uVKEI"};